// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__lgIAO","consentsList":"PatientConsents_consentsList__1eTG_","consentsListEmpty":"PatientConsents_consentsListEmpty__3Vr9B"};